import { useContext, useEffect, useRef, useState } from "react";
import { Formik, Form, FieldArray } from "formik";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import CustomSelect from "../../components/CustomSelect";
import ComponentInput from "../../components/componentInput";
import { UserContext } from "../../contexts/UserContext";
import { CreateBlogAPI, CreateContentFAQ, GetAllTypes, UploadImageArticle } from "../../helpers/api";
import AddImage from "../../assets/icons/iconAddImage.svg";
import { useNavigate } from "react-router-dom";
import IconAdd from '../../assets/icons/iconAdd.svg'
// import { toast } from "react-toastify";

const modules = {
  toolbar: [
    [{ header: [2, 3, 4, 5, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "link",
];

const CreateBlog = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [titleFAQ, setTitleFAQ] = useState("FAQ");
  const [error, setError] = useState(null);
  const [ListeCategorie, setListeCategorie] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [imageError, setImageError] = useState(false);
  const [imageContentError, setImageContentError] = useState(false);
  const [isValueSlug, setIsValueSlug] = useState("");

  const topRef = useRef(null);
 
  const initialValues = {
    type: "",
    slug: "",
    blogTitle: "",
    shortDescription: "",
    // tags: [],
    tags:"",
    auteur: "",
    metadata: { title: "", description: "" },
    published: true,
    articlePrefer: false,
    articleCategoriePrefer: false,
    mainImageFile: null,
    mainImagePreview: null,
    contentBlocks: [
      {
        titleContent: "",
        paragraphe: "",
        file: null,
        imagePreviewUrl: "",
      },
    ],
    faq: [
      {
        title: "",
        paragraphe: "",
        faqTitle: "FAQ",
      },
    ],
  };

  const handleSubmitForm = async (values, { setSubmitting }) => {
    setError(null);
    // const dataPayload = new FormData();
    //  const dataPayloadContent = new FormData();

    // dataPayload.append("type", values.type);
    // dataPayload.append("slug", values.slug);
    // dataPayload.append("blogTitle", values.blogTitle);
    // dataPayload.append("shortDescription", values.shortDescription);
    // dataPayload.append("tags", JSON.stringify(values.tags));
    // dataPayload.append("auteur", values.auteur);
    // dataPayload.append("published", values.published);
    // dataPayload.append("articlePrefer", values.articlePrefer);
    // dataPayload.append("articleCategoriePrefer", values.articleCategoriePrefer);
    // dataPayload.append("metadata", JSON.stringify(values.metadata));
    //   let imageCounter = 1;
    // const contentBlocksWithKeys = values.contentBlocks.map((block) => {
    //   let currentKey = "";

    //   if (block.file) {
    //     currentKey = `contentImage${imageCounter}`;
    //     dataPayloadContent.append(currentKey, block.file);
    //     imageCounter++;
    //   }

    //   return {
    //     titleContent: block.titleContent,
    //     paragraphe: block.paragraphe,
    //     imageKey: currentKey,
    //   };
    // });

    // const finalizedFaq = values.faq.map((item) => ({
    //   ...item,
    //   faqTitle: titleFAQ,
    // }));
    // dataPayloadContent.append("faq", JSON.stringify(finalizedFaq));
    // dataPayloadContent.append("content", JSON.stringify(contentBlocksWithKeys));

    
    const buildPayloadImage = new FormData();

    const buildBlogPayload = {
      type: values.type,
      slug: values.slug,
      metadata: {
        title: values.metadata.title,
        description: values.metadata.description,
      },
      blogTitle: values.blogTitle,
      shortDescription: values.shortDescription,
      // tags: values.tags.join(","),
      tags: values.tags,
      auteur: values.auteur,
      published: values.published,
      articlePrefer: values.articlePrefer,
      articleCategoriePrefer: values.articleCategoriePrefer,
    }
    const buildContentFAQPayload=
    { content: values.contentBlocks.map((block, index)=>{
      if(block.file)
      {buildPayloadImage.append(`contentImage${index + 1}`, block.file)}
      return{
      imageKey: block.file ? `contentImage${index + 1}` : "",
      titleContent: `block.titleContent${index + 1}`,
      paragraphe: block.paragraphe
      }
    }),
    faq:values.faq.map((faq, index)=>({
      faqTitle: faq.faqTitle,
      title: faq.title,
      paragraphe: faq.paragraphe
    }))}


    if (values.mainImageFile) {
      buildPayloadImage.append("image", values.mainImageFile);
    }

    const hasInvalidContent = values.contentBlocks.some(
      (block) =>
        !block.paragraphe.trim()
    );

    const hasInvalidFaq = values.faq.some(
      (faq) =>
        !faq.title.trim() ||
        !faq.paragraphe.trim()
    );
    try {
      // Vérification des champs obligatoires
      if(!values.mainImageFile)
        { return setError('Cover image is required') }
      if(hasInvalidContent)
        { return setError('Please complete all content blocks') }
      if(hasInvalidFaq)
        { return setError('Please complete all FAQ fields') }

      //1ére etape creation du blog
      const responseBlog = await CreateBlogAPI(buildBlogPayload);
      let idArticle= responseBlog.data.id

      // toast("Article created ");
        if (!responseBlog?.success && !idArticle) 
            {throw new Error("Erreur lors de la création du blog.");}
      //2eme etape creation du contenu et faq
      const responseContentFAQ = await CreateContentFAQ (buildContentFAQPayload, idArticle)
        if(!responseContentFAQ?.success)
          {throw new Error("Erreur lors de l'ajout du contenu .");}

      
      const resUploadImage= await UploadImageArticle(buildPayloadImage, idArticle )
        if(!resUploadImage.success)
          {throw new Error("Erreur lors de l'ajout des images.");}
        navigate("/super-agent-list-blogs")         
      
    } catch (err) {
      setError(err.response?.data.message || "Error occurred");
    } finally {
      setSubmitting(false);
    }
  };

 


//   const validateImageDimensions = (file, typeImage) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     const objectUrl = URL.createObjectURL(file);
    
     
//     if(typeImage==='header')
//     img.onload = () => {
//       const { naturalWidth, naturalHeight } = img;
//       const verificationIamge= typeImage==='header'?
//         naturalWidth >= IMAGE_DIMENSIONS[typeImage].minWidth  && naturalHeight >= IMAGE_DIMENSIONS[typeImage].minHeight
//       :
//         naturalWidth <= IMAGE_DIMENSIONS[typeImage].minWidth  && naturalHeight <= IMAGE_DIMENSIONS[typeImage].minHeight

//       if (verificationIamge) {
//         resolve(objectUrl); // on garde l'URL, elle sera utilisée pour la preview
//       } else {
//         URL.revokeObjectURL(objectUrl); // on ne garde pas cette URL, on la libère
//         reject(
//           `Dimensions invalides : Minimum ${IMAGE_DIMENSIONS[typeImage].minWidth}x${IMAGE_DIMENSIONS[typeImage].minHeight}px. `
//         );
//       }
//     };

//     img.onerror = () => {
//       URL.revokeObjectURL(objectUrl);
//       reject("Impossible de lire ce fichier comme image.");
//     };

//     img.src = objectUrl;
//   });
// };
const IMAGE_DIMENSIONS = {
  header: {
    minWidth: 1200,
    minHeight: 600,
  },
  content: {
    maxWidth: 800,
    maxHeight: 600,
  },
};

const validateImageDimensions = (file, imageType) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);

    image.onload = () => {
      const { naturalWidth, naturalHeight } = image;

      let isValid = false;

      if (imageType === "header") {
        const { minWidth, minHeight } = IMAGE_DIMENSIONS.header;

        isValid =
          naturalWidth >= minWidth &&
          naturalHeight >= minHeight;
      } else if (imageType === "content") {
        const { maxWidth, maxHeight } = IMAGE_DIMENSIONS.content;

        isValid =
          naturalWidth <= maxWidth &&
          naturalHeight <= maxHeight;
      }

      if (isValid) {
        resolve(objectUrl);
      } else {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("Invalid image dimensions"));
      }
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Unable to read image"));
    };

    image.src = objectUrl;
  });
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GetAllTypes();

        if (response?.success) {
          const formattedData = response?.data?.map((item) => {
            const capitalized = item.charAt(0).toUpperCase() + item.slice(1);

            return {
              value: item,
              label: capitalized,
            };
          });
          setListeCategorie(formattedData);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };

    fetchData();
  }, []);

  const slugify = (text) => {
  return text
    .toString()
    .normalize("NFD")                   // décompose les accents (é -> e + ́)
    .replace(/[\u0300-\u036f]/g, "")    // supprime les accents
    .toLowerCase()                       // tout en minuscule
    .trim()                              // supprime espaces début/fin
    .replace(/[^a-z0-9\s-]/g, "")        // supprime caractères spéciaux
    .replace(/\s+/g, "-")                // remplace espaces par -
    .replace(/-+/g, "-")                 // supprime tirets multiples
    // .replace(/^' '+|-+$/g, "");            // supprime tirets début/fin
};

 useEffect(() => {
  if (error && topRef.current) {
    setTimeout(() => {
      topRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }
}, [error]);
  return (
    <div ref={topRef} className="mx-auto p-6 bg-white rounded-lg shadow">
      <h1 className="h2-title text-left mb-4">Create New Blog Post</h1>

      {error && <p className="text-[#EE443F] mb-4">{error}</p>}

      <Formik initialValues={initialValues} onSubmit={handleSubmitForm}>
        {({ values, handleChange, setFieldValue, isSubmitting }) => 
        {

          const handleInputChange = (e) => {
            if (error) {
              setError(null);
            }
            handleChange(e);
          };

          const isMetadataTitleValid =
            values.metadata.title.trim().length >= 30 &&
            values.metadata.title.trim().length <= 60;

          const isMetadataDescriptionValid =
            values.metadata.description.trim().length >= 120 &&
            values.metadata.description.trim().length <= 160;

          const isBlogTitleValid =
            values.blogTitle.trim().length >= 10 &&
            values.blogTitle.trim().length <= 70;

          const isShortDescriptionValid =
            values.shortDescription.trim().length >= 50 &&
            values.shortDescription.trim().length <= 250;
            const isFormValid =
            isMetadataTitleValid &&
            isBlogTitleValid &&
            isMetadataDescriptionValid &&
            isShortDescriptionValid


          // const isFormValid =
          //   values.type.trim() !== "" &&
          //   values.slug.trim() !== "" &&
          //   values.blogTitle.trim() !== "" &&
          //   values.shortDescription.trim() !== "" &&
          //   values.metadata.title.trim() !== "" &&
          //   values.metadata.description.trim() !== "" &&
          //   values.mainImageFile &&
          //   values.contentBlocks.every(
          //     (block) =>
          //       block.paragraphe.trim() !== ""
               
          //   ) &&
          //   values.faq.every(
          //     (item) =>
          //       item.title.trim() !== "" &&
          //       item.paragraphe.trim() !== ""
          //   );

          return(
          
          <Form className="flex flex-col gap-8 mt-8">
            <label
              className={`${
                values.mainImagePreview ? "bg-transparent" : "bg-[#F1F1FF]"
              } w-full relative rounded-[10px] min-h-[136px] flex items-center justify-center flex-col`}
            >
              {values.mainImagePreview && (
                <img
                  src={values.mainImagePreview}
                  alt="Preview"
                  className="h-[500px] w-full object-cover rounded mt-4"
                />
              )}
              <div className="absolute flex flex-col items-center  space-y-2">
                <img
                  className=""
                  width={32}
                  height={32}
                  src={AddImage}
                  alt=""
                />
                {!values.mainImagePreview && (
                  <p className="text-[#808091] text-[10px]">
                    Add a cover picture <br />
                      (Minimum dimensions: {IMAGE_DIMENSIONS['header'].minWidth} × {IMAGE_DIMENSIONS['header'].minHeight} px)
                  </p>
                )}
              </div>
              <input
                type="file"
                accept="image/*"
                onChange={ async(e)=>{
                  const file = e.target.files[0];
                  if (!file) return
                  setImageError(false)
                  try{
                    const validUrl = await validateImageDimensions(file, 'header');
                    setFieldValue("mainImageFile", file);
                    setFieldValue("mainImagePreview", validUrl);
                    setError(null)
                  }catch{
                    setImageError(true);
                    setFieldValue("mainImageFile", null);
                    setFieldValue("mainImagePreview", null);
                    e.target.value = ""; 

                  }

                }}
                // onChange={(e) => {
                //   const file = e.target.files[0];
                //   if (file) {
                //     setFieldValue("mainImageFile", file);
                //     setFieldValue(
                //       "mainImagePreview",
                //       URL.createObjectURL(file)
                //     );
                //   }
                // }}
                className="hidden mt-4"
              />
            </label>
              {imageError && (
                <p className="text-red-500 text-[12px] mt-1">The image must be at least {IMAGE_DIMENSIONS['header'].minWidth} x {IMAGE_DIMENSIONS['header'].minHeight} pixels.</p>
              )}

            
            <div className="xl:flex w-full gap-3 justify-between  items-end">
              <CustomSelect
                label='Article Category'
                isRequired={true}
                sizeTexte="w-full"
                styleInput="h-[56px]"
                id="type"
                options={ListeCategorie}
                value={values.type}
                placeholder="Select a Category"
                onChange={(val, id) => setFieldValue(id, val)}
                styleSlect="top-full "
              />

              <div className="flex w-full flex-wrap lg:gap-6 gap-2 mt-6 xl:mt-0 items-center  justify-between xl:h-[56px] py-2 px-6 rounded-[8px] bg-[#F1F1FF] h-full border border-gray-100">
                <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-[12px] text-[#333F51]">
                  <input
                    type="checkbox"
                    name="published"
                    checked={values.published}
                    onChange={(e) =>
                      setFieldValue("published", e.target.checked)
                    }
                    className="w-4 h-4 rounded  border-[#5754E5] shadow-[2px_2px_6px_rgba(209,209,255,0.8)] text-blue-600 focus:ring-blue-500"
                  />
                  Published
                </label>

                <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700">
                  <input
                    type="checkbox"
                    name="articlePrefer"
                    checked={values.articlePrefer}
                    onChange={(e) =>
                      setFieldValue("articlePrefer", e.target.checked)
                    }
                    className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  Featured Article
                </label>

                <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700">
                  <input
                    type="checkbox"
                    name="articleCategoriePrefer"
                    checked={values.articleCategoriePrefer}
                    onChange={(e) =>
                      setFieldValue("articleCategoriePrefer", e.target.checked)
                    }
                    className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  Featured Category
                </label>
              </div>
            </div>
            <ComponentInput
              isRequired={true}
              placeholder="Metadata Title"
              label="Metadata Title"
              name="metadata.title"
              valueInput={values.metadata.title}
              onChange={handleInputChange}
              maxLength={60}
              minLength={30}
            />

            <ComponentInput
              isRequired={true}
              placeholder="Metadata Description"
              label="Metadata Description"
              name="metadata.description"
              valueInput={values.metadata.description}
              onChange={handleInputChange}
              maxLength={160}
              minLength={120}
            />
           
            <ComponentInput
              isRequired={true}
              placeholder="Article Title"
              label="Article Title"
              name="blogTitle"
              valueInput={values.blogTitle}
              maxLength={70}
              minLength={10}
              onChange={(e)=>
                {handleInputChange(e)
                  // handleChange(e)
                  const val= e.target.value.replace(/^[^a-zA-Z0-9À-ÿ]+|[^a-zA-Z0-9À-ÿ\s'-]+$/g, "")
                  if(!isValueSlug)
                  { setFieldValue('slug', slugify(val))}
                }
              }
            />

            <ComponentInput
              isRequired={true}
              typeInput="textarea"
              placeholder="Short Description"
              label="Short Description"
              name="shortDescription"
              valueInput={values.shortDescription}
              maxLength={250}
              minLength={50}
              onChange={handleInputChange}
            />
            
            <ComponentInput
              isRequired={true}
              placeholder="Slug"
              label="Slug"
              name="slug"
              valueInput={values.slug}
              onChange={(e) => {
                // if(/^(?!.*__)[A-Za-z_]*$/.test(e.target.value))
                //     {
                      setIsValueSlug(slugify(e.target.value))
                      setFieldValue("slug", slugify(e.target.value))
                      setError(null)
                    // }
                  
                }}
            />

            <ComponentInput
              placeholder="Author"
              label="Author"
              name="auteur"
              valueInput={values.auteur}
              onChange={handleInputChange}
            />

            {/* <ComponentInput
              placeholder="Tags"
              label="Tags"
              name="tags"
              valueInput={values.tags}
              onChange={handleInputChange}
            /> */}

            {/* <div className="flex flex-col gap-2">
              <label className="pl-2 mb-2 text-[#422EAE]  font-bold flex items-start">
                Tags
              </label>

              <div className="flex flex-wrap gap-2 items-center p-2 border  rounded-[16px] min-h-[50px] bg-white border-[#AEB6FB] h-[56px] ">
                {values.tags.map((tag, idx) => (
                  <span
                    key={idx}
                    className="flex items-center gap-1.5 bg-[#F1F1FF] text-[#5754E5] font-semibold text-[13px] px-3 py-1 rounded-[8px] h-[39px] "
                  >
                    {tag}
                    <button
                      type="button"
                      onClick={() => {
                        const nextTags = values.tags.filter(
                          (_, i) => i !== idx
                        );
                        setFieldValue("tags", nextTags);
                      }}
                      className="text-[#5754E5] hover:text-red-500 font-bold ml-0.5 text-[14px] leading-none transition-colors"
                    >
                      &times;
                    </button>
                  </span>
                ))}

                <input
                  type="text"
                  value={tagInput}
                  placeholder={
                    values.tags.length === 0 ? "Type a tag and press Enter" : ""
                  }
                  className="flex-1 outline-none border-none text-[18px] px-2 min-w-[120px] h-[32px] placeholder-[#D1D1FF] text-[#35258B]"
                  onChange={(e) => setTagInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Stop form context submission
                      const trimmedValue = tagInput.trim();
                      if (trimmedValue && !values.tags.includes(trimmedValue)) {
                        setFieldValue("tags", [...values.tags, trimmedValue]);
                        setTagInput("");
                      }
                    }
                  }}
                />
              </div>
            </div> */}

            <FieldArray name="contentBlocks">
              {({ push, remove }) => (
                <div>
                  {values.contentBlocks.map((block, index) => (
                    <div
                      key={index}
                      className="mt-6  bg-[#F1F1FF] rounded-[6px]  p-4  relative"
                    >
                      <div className="flex justify-between items-center mb-2">
                        <label className="text-[16px] text-[#5754E5] font-medium">
                          Content Block {index + 1} <span className='text-[#EE443F]'>*</span>
                        </label>
                        {values.contentBlocks.length > 1 && (
                          <button
                            type="button"
                            onClick={() => remove(index)}
                            className="text-red-500 hover:text-red-700 font-medium text-sm border border-red-200 px-2 py-1 rounded transition-colors"
                          >
                            ❌ Delete Block
                          </button>
                        )}
                      </div>

                      <ReactQuill
                        value={block.paragraphe}
                        placeholder="Write something..."
                        onChange={(value) =>
                         
                          {setFieldValue(
                            `contentBlocks[${index}].paragraphe`,
                            value
                          )
                           setError(null)}
                        }
                        modules={modules}
                        formats={formats}
                        theme="snow"
                        className="custom-quill min-h-[150px]"
                      />

                      <label className="flex flex-col  items-center my-4">
                        <span className=" flex items-center justify-center font-bold gap-2 cursor-pointer text-[#5754E5] border border-[#5754E5] text-[14px] rounded-[12px] px-4 h-[40px] ">
                          <img src={AddImage} width={24} height={24} alt=" " />
                          Cover image is required
                        </span>
                        <input
                          type="file"
                          accept="image/*"

                          
                          onChange={async(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              try{
                              const validUrl = await validateImageDimensions(file, 'content');
                              setFieldValue(`contentBlocks[${index}].file`,file);
                              // setFieldValue(`contentBlocks[${index}].imagePreviewUrl`, URL.createObjectURL(file));
                              setFieldValue(`contentBlocks[${index}].imagePreviewUrl`,validUrl);
                              setImageContentError(false)
                              }
                              catch{
                                setImageContentError(true)
                              setFieldValue(`contentBlocks[${index}].imagePreviewUrl`,null);


                              }
                            }
                          }}
                          className="hidden"
                        />
                       {imageContentError ? (
                          <p className="text-red-500 text-[12px] mt-1">
                            The image size must not exceed {IMAGE_DIMENSIONS['content'].minLength} x {IMAGE_DIMENSIONS['content'].minHeight} pixels.
                          </p>
                        ) : block.imagePreviewUrl ? (
                          <img
                            src={block.imagePreviewUrl}
                            alt="Preview"
                            className="h-full w-[100px] object-cover rounded mt-2"
                          />
                        ) : (
                          <div className="mt-2 text-[#808091] text-[12px]">
                            No file selected
                          </div>
                        )}
                      </label>
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() =>
                      push({
                        titleContent: "",
                        paragraphe: "",
                        file: null,
                        imagePreviewUrl: "",
                      })
                    }
                    className="text-[#5754E5] flex items-center justify-center gap-4 text-[12px] bg-[#F1F1FF] w-full py-4 rounded-[6px] mt-3 self-start"
                  >
                    <img src={IconAdd} alt="Add Another Content Block"/> Add Another Content Block
                  </button>
                </div>
              )}
            </FieldArray>

            <FieldArray name="faq">
              {({ push, remove }) => (
                <div>
                  <div className="mt-6  bg-[#F1F1FF] rounded-[6px]  p-4  relative">
                    {values.faq.map((item, index) => (
                      <div
                        key={index}
                        className="mt-6 border border-[#AEB6FB] p-4 rounded"
                      >
                        <div className="flex justify-between items-center mb-2">
                          <span className="text-[16px] text-[#5754E5] font-medium">
                            FAQ Item {index + 1} <span className='text-[#EE443F]'>*</span>
                          </span>
                          {values.faq.length > 1 && (
                            <button
                              type="button"
                              onClick={() => remove(index)}
                              className="text-red-500 hover:text-red-700 font-medium text-sm border border-red-200 px-2 py-1 rounded transition-colors"
                            >
                              ❌ Delete FAQ
                            </button>
                          )}
                        </div>

                        <ComponentInput
                          styleInput="flex item-center border-none justify-center mb-2"
                          placeholder={`Question ${index + 1}`}
                          name={`faq[${index}].title`}
                          valueInput={item.title}
                          onChange={handleInputChange
                            // handleChange
                          }
                        />
                        <ReactQuill
                          value={item.paragraphe}
                          onChange={(value) =>
                           { setFieldValue(`faq[${index}].paragraphe`, value)
                              setError(null)
                          }
                          }
                          modules={modules}
                          formats={formats}
                          theme="snow"
                          className="custom-quill min-h-[150px]"
                          placeholder="Write something..."
                        />
                      </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={() =>
                      push({ title: "", paragraphe: "", faqTitle: "FAQ" })
                    }
                    className="text-[#5754E5] flex items-center justify-center gap-4 text-[12px] bg-[#F1F1FF] w-full py-4 rounded-[6px] mt-3 self-start"
                  >
                    <img src={IconAdd} alt="Add Another Content Block"/> Add Another FAQ
                  </button>
                </div>
              )}
            </FieldArray>

            <button
              type="submit"
              disabled={isSubmitting || error || !isFormValid }
              className={` ${isSubmitting || error || !isFormValid ? 'bg-[#D1D1FF]' :'bg-[#5754E5]'}  text-white text-[16px] font-bold  h-[56px] rounded-[16px] mt-5 w-2/3 mx-auto`}
            >
              {isSubmitting ? "Submitting..." : "Create Blog Post"}
            </button>
          </Form>
        )}}
      </Formik>
    </div>
  );
};

export default CreateBlog;
